import { render } from "./DumpingGroundDashboard.vue?vue&type=template&id=0e7c547a&scoped=true"
import script from "./DumpingGroundDashboard.vue?vue&type=script&lang=js"
export * from "./DumpingGroundDashboard.vue?vue&type=script&lang=js"

import "./DumpingGroundDashboard.vue?vue&type=style&index=0&id=0e7c547a&lang=css"
import "./DumpingGroundDashboard.vue?vue&type=style&index=1&id=0e7c547a&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e7c547a"]])

export default __exports__